import { Record, Map, List } from "immutable";
import { AnyAction } from "redux";

import { SingleOption, UserOptionRaw } from "@typings/userOptions";

import {
  ACTION_FAIL,
  ACTION_SUCCESS,
} from "@services/AsyncActionCreatorFactory";

import { SAVE_OPTION, FETCH_OPTIONS } from "./userOptions.actions";
import { IUserOptions } from "./userOptions.typings";

export type UserOptionsReducer = Record<IUserOptions>;

const initialState = Record<IUserOptions>({
  options: null,
});

const initialSingleOption = Record<SingleOption>({
  key: "",
  value: "",
  allowedValues: List(),
});

const userOptionsReducer = (
  store: UserOptionsReducer = new initialState(),
  action: AnyAction,
): Record<IUserOptions> => {
  const { type, params, payload } = action;

  switch (type) {
    case `${FETCH_OPTIONS}${ACTION_SUCCESS}`: {
      const userOptions = payload.data;

      if (typeof userOptions.options === "undefined") {
        return store;
      }

      const newOptions = userOptions.options.reduce(
        (acc: Map<string, SingleOption>, opt: UserOptionRaw) => {
          return acc.set(
            opt.key,
            initialSingleOption({
              ...opt,
              allowedValues: List(opt.allowedValues),
            }),
          );
        },
        Map(),
      );

      return store.merge({
        ...userOptions,
        options: newOptions,
      });
    }

    case `${FETCH_OPTIONS}${ACTION_FAIL}`: {
      if (store.get("options") === null) {
        return store.set("options", Map());
      }

      return store;
    }

    case `${SAVE_OPTION}${ACTION_SUCCESS}`: {
      const { option, value } = params;

      if (Map.isMap(store.get("options"))) {
        return store.setIn(["options", option, "value"], value);
      }

      return store
        .set("options", Map())
        .setIn(["options", option, "value"], value);
    }

    case `${SAVE_OPTION}${ACTION_FAIL}`: {
      return store;
    }

    default: {
      return store;
    }
  }
};

export { userOptionsReducer };
